import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as h } from "react";
const r = ({
  title: o,
  titleId: l,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...i,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M554.675 405.329v-85.333c0-23.552 19.115-42.667 42.667-42.667h42.667V170.662h-85.333c-70.699 0-128 57.301-128 128v106.667h-85.333v106.667h85.333v341.333h128V511.996h85.333l42.667-106.667h-128z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = h(r);
export {
  m as default
};
